import { NewsList } from 'ui/components/3-organisms/NewsList/NewsList';
import { NewsFetcher } from './NewsFetcher';

import { useState } from 'react';
import { useDictionaryContext } from 'application/contexts/DictionaryContext';

export const NewsListFeature: React.FC<Content.NewsList> = ({ content }) => {
	const [activeTag] = useState<Tags.Tag | null>(null);
	const dictionary = useDictionaryContext();

	const allTranslation = dictionary.getValue('All');

	return (
		<NewsList
			{...content?.properties}
			rootFolderId={content?.properties.rootFolder.id}
			newsFetcher={(rootId, limit, offset, filter) => NewsFetcher(rootId, limit, offset, filter, activeTag, allTranslation)}
			bgColor={content?.properties?.color}
		/>
	);
};
